export default {"src":"/_next/static/media/DNB.7f3c7a7a.svg","height":18,"width":18};